export class InvalidEgnError extends Error {

    public constructor() {
        super('Invalid EGN');
        Object.setPrototypeOf(this, InvalidEgnError.prototype);
    }

}
